import React, { memo, forwardRef } from "react";
const SvgGas = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M21.707 9.293a1 1 0 01-1.414 1.414L17 7.414V27a1 1 0 11-2 0V7.414l-3.293 3.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0l5 5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgGas.displayName = "SvgGas";
const MemoForwardRef = memo(SvgGas);
export default MemoForwardRef;
